import React, { useEffect, useState } from "react";
import { BsArrowDownRight, BsArrowUpRight } from "react-icons/bs";
import { Column } from "@ant-design/plots";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getMonthlyData,
  getOrders,
  getYearlyData,
} from "../features/auth/authSlice";
import { useTheme } from "../contexts/ThemeContext";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
    className: "text-text-light dark:text-text-dark bg-white dark:bg-surface-dark",
  },
  {
    title: "Name",
    dataIndex: "name",
    className: "text-text-light dark:text-text-dark bg-white dark:bg-surface-dark",
  },
  {
    title: "Product Count",
    dataIndex: "product",
    className: "text-text-light dark:text-text-dark bg-white dark:bg-surface-dark",
  },
  {
    title: "Total Price",
    dataIndex: "price",
    className: "text-text-light dark:text-text-dark bg-white dark:bg-surface-dark",
  },
  {
    title: "Total Price After Discount",
    dataIndex: "dprice",
    className: "text-text-light dark:text-text-dark bg-white dark:bg-surface-dark",
  },
  {
    title: "Status",
    dataIndex: "staus",
    className: "text-text-light dark:text-text-dark bg-white dark:bg-surface-dark",
  },
];

const Dashboard = () => {
  const dispatch = useDispatch();
  const { darkMode } = useTheme();

  const monthlyDataState = useSelector((state) => state?.auth?.monthlyData);
  const yearlyDataState = useSelector((state) => state?.auth?.yearlyData);
  const orderState = useSelector((state) => state?.auth?.orders?.orders);
  console.log(orderState);

  const [dataMonthly, setDataMonthly] = useState([]);
  const [dataMonthlySales, setDataMonthlySales] = useState([]);
  const [orderData, setOrderData] = useState([]);

  const getTokenFromLocalStorage = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const config3 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
      }`,
      Accept: "application/json",
    },
  };

  useEffect(() => {
    dispatch(getMonthlyData(config3));
    dispatch(getYearlyData(config3));
    dispatch(getOrders(config3));
  }, []);

  useEffect(() => {
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let data = [];

    let monthlyOrderCount = [];
    for (let index = 0; index < monthlyDataState?.length; index++) {
      const element = monthlyDataState[index];
      data.push({
        type: monthNames[element?._id?.month],
        income: element?.amount,
      });
      monthlyOrderCount.push({
        type: monthNames[element?._id?.month],
        income: element?.count,
      });
    }

    setDataMonthly(data);
    setDataMonthlySales(monthlyOrderCount);

    const data1 = [];

    for (let i = 0; i < orderState?.length; i++) {
      data1.push({
        key: i,
        name: orderState[i].user.firstname + " " + orderState[i].user.lastname,
        product: orderState[i].orderItems?.length,
        price: orderState[i]?.totalPrice,
        dprice: orderState[i]?.totalPriceAfterDiscount,
        staus: orderState[i]?.orderStatus,
      });
    }
    setOrderData(data1);
  }, [monthlyDataState, yearlyDataState]);

  const config = {
    data: dataMonthly,
    xField: "type",
    yField: "income",
    color: ({ type }) => {
      return darkMode ? "#e6c229" : "#ffd333";
    },
    label: {
      position: "middle",
      style: {
        fill: darkMode ? "#f8f9fa" : "#212529",
        opacity: 1,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
        style: {
          fill: darkMode ? "#f8f9fa" : "#212529",
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fill: darkMode ? "#f8f9fa" : "#212529",
        },
      },
    },
    meta: {
      type: {
        alias: "Month",
      },
      sales: {
        alias: "Income",
      },
    },
  };

  const config2 = {
    data: dataMonthlySales,
    xField: "type",
    yField: "income",
    color: ({ type }) => {
      return darkMode ? "#e6c229" : "#ffd333";
    },
    label: {
      position: "middle",
      style: {
        fill: darkMode ? "#f8f9fa" : "#212529",
        opacity: 1,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
        style: {
          fill: darkMode ? "#f8f9fa" : "#212529",
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fill: darkMode ? "#f8f9fa" : "#212529",
        },
      },
    },
    meta: {
      type: {
        alias: "Month",
      },
      sales: {
        alias: "Income",
      },
    },
  };

  return (
    <div className="bg-background-light dark:bg-background-dark p-4">
      <h3 className="mb-6 title text-2xl font-bold">Dashboard</h3>
      
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
        <div className="bg-gradient-to-r from-primary-light to-yellow-400 dark:from-gray-800 dark:to-gray-900 p-4 md:p-6 rounded-2xl shadow-lg dark:shadow-gray-800 transform transition-transform hover:scale-105">
          <div className="flex justify-between items-start">
            <div>
              <p className="desc text-white text-opacity-80 mb-2 text-sm md:text-base">Total Income</p>
              <h4 className="mb-0 sub-title text-white text-2xl md:text-3xl font-bold">
                Rs.{yearlyDataState && yearlyDataState[0]?.amount}
              </h4>
            </div>
            <div className="bg-white bg-opacity-20 p-2 md:p-3 rounded-full">
              <BsArrowUpRight className="text-white text-xl md:text-2xl" />
            </div>
          </div>
          <p className="mb-0 desc text-white text-opacity-80 mt-2 md:mt-4 text-xs md:text-sm">Income in Last Year from Today</p>
        </div>
        
        <div className="bg-gradient-to-r from-blue-500 to-indigo-600 dark:from-gray-800 dark:to-gray-900 p-4 md:p-6 rounded-2xl shadow-lg dark:shadow-gray-800 transform transition-transform hover:scale-105">
          <div className="flex justify-between items-start">
            <div>
              <p className="desc text-white text-opacity-80 mb-2 text-sm md:text-base">Total Sales</p>
              <h4 className="mb-0 sub-title text-white text-2xl md:text-3xl font-bold">
                {yearlyDataState && yearlyDataState[0]?.count}
              </h4>
            </div>
            <div className="bg-white bg-opacity-20 p-2 md:p-3 rounded-full">
              <BsArrowDownRight className="text-white text-xl md:text-2xl" />
            </div>
          </div>
          <p className="mb-0 desc text-white text-opacity-80 mt-2 md:mt-4 text-xs md:text-sm">Sales in Last Year from Today</p>
        </div>
      </div>
      
      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 mb-6 md:mb-8">
        <div className="bg-white dark:bg-surface-dark p-4 md:p-6 rounded-2xl shadow-lg dark:shadow-gray-800">
          <h3 className="mb-3 md:mb-5 title text-lg md:text-xl font-semibold">Income in Last Year from Today</h3>
          <div className="h-64 md:h-80">
            <Column {...config} />
          </div>
        </div>
        
        <div className="bg-white dark:bg-surface-dark p-4 md:p-6 rounded-2xl shadow-lg dark:shadow-gray-800">
          <h3 className="mb-3 md:mb-5 title text-lg md:text-xl font-semibold">Sales in Last Year from Today</h3>
          <div className="h-64 md:h-80">
            <Column {...config2} />
          </div>
        </div>
      </div>
      
      {/* Recent Orders */}
      <div className="bg-white dark:bg-surface-dark p-4 md:p-6 rounded-2xl shadow-lg dark:shadow-gray-800">
        <h3 className="mb-3 md:mb-5 title text-lg md:text-xl font-semibold">Recent Orders</h3>
        <div className="overflow-x-auto">
          <Table 
            columns={columns} 
            dataSource={orderData} 
            className="bg-white dark:bg-surface-dark"
            pagination={{
              className: "text-text-light dark:text-text-dark",
            }}
            scroll={{ x: true }}
            size="small"
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;